/* Section omponents angular */
import { Component, OnInit } from '@angular/core';
import { FormGroup } from "@angular/forms";
/* End section components angular */

/* Section components project */
import Toast from 'modern-toastr';
import { ToastrService } from "ngx-toastr";
import { APP } from "./../constants";
import { LocalStorageService } from 'angular-2-local-storage';
import { Router } from '@angular/router';
import { loginClass } from './login.class';
import { LoginService } from './login.service';
import { AuthService } from '@app/services/auth.service';
import { EmpresaService } from '@app/services/empresa.service';

/* End section components project */

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  formData: loginClass

  appBaseUrl = APP.AppBaseUrl;
  empresasListado: any = [];

  constructor(private auth: AuthService, 
              private authService: LoginService, 
              private _localStorageService: LocalStorageService, 
              private toastr: ToastrService, 
              private router: Router,
              private _EmpresaService: EmpresaService) {
    this.formData = new loginClass(null, null, null)
  }

  ngOnInit() {
    this.getEmpresas();
  }

  async getEmpresas() {
    await this._EmpresaService.listarMain({}, (data: { filas: { recordsets: any[] } }) => {
        this.empresasListado = data.filas.recordsets[0];
      }
    );
  }

  async login(data: FormGroup) {
    if(this.formData.id_empresa == null){
      this.toastr.warning("Debe seleccionar una empresa");
      return false;
    }

    this.authService.Login({
      id_empresa: this.formData.id_empresa,
      user: this.formData.user,
      pass: this.formData.pass
    }, async (result) => {
      if (result.status) {
        this._localStorageService.set('tokenUserActive', result.results.token);
        await this.auth.cargarDataUsuario({}, async dataUser => {
          if (dataUser.decodeToken.sub.validar_licencia) {
            // await this.auth.validar_licencia(dataUser.decodeToken.sub.urlApiLicencia, data_licencia => {
            //   if (data_licencia.data[0].permite) {
            //     if (data_licencia.data[0].notifica) this.toastr.info(data_licencia.data[0].notificacion, 'Licencia');
            //     this.toastr.success(result.description, result.message);
            //     const previousPage = this._localStorageService.get('PreviousPage');
            //     if (previousPage != null && previousPage != '' && previousPage != undefined) {
            //       window.location.replace(`${this.appBaseUrl}/#/app/${previousPage}`);
            //     } else {
            //       window.location.replace(`${this.appBaseUrl}/#/app`);
            //     }
            //   } else {
            //     if (data_licencia.data[0].notifica) this.toastr.error(data_licencia.data[0].notificacion, 'Licencia');
            //   }
            // });
          } else {
            this.toastr.success(result.description, result.message);
            const previousPage = this._localStorageService.get('PreviousPage');
            if (previousPage != null && previousPage != '' && previousPage != undefined) {
              window.location.replace(`${this.appBaseUrl}/#/app/${previousPage}`);
            } else {
              window.location.replace(`${this.appBaseUrl}/#/app`);
            }
          }
        });
      } else {
        this.formData.pass = ''
        this.toastr.error(result.description, result.message);
      }
    });
  }

}
